//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  export default {
    data () {
      return {}
    },
    methods: {
      backOrderDetail () {
        console.log(this.$route.param)
        this.$router.push({path: '/orderDetail/' + this.$route.params.orderId, query: {cid: this.$route.query.cid}})
      }
    }
  }



// WEBPACK FOOTER //
// ./src/components/pay/PayMoney.vue